export const PagingConstants = {
  INITIAL_ROW_AMOUNT: 25,
  TEN_ROW_AMOUNT: 10,
  FIFTY_ROW_AMOUNT: 50,
  HUNDRED_ROW_AMOUNT: 100,
};
